@font-face {
  font-family: "Marianne";
  src: url("./Marianne-ExtraBold.woff") format("opentype");
  font-weight: 800;
  font-style: normal;
}

@font-face {
  font-family: "Marianne";
  src: url("./Marianne-Medium.woff") format("opentype");
  font-weight: 500;
}

@font-face {
  font-family: "Marianne";
  src: url("./Marianne-Bold.woff") format("opentype");
  font-weight: 700;
}

@font-face {
  font-family: "Marianne";
  src: url("./Marianne-Regular.woff") format("opentype");
  font-weight: 400;
}

.costText {
  font-family: "Marianne";
  font-weight: 800;
  letter-spacing: 0;
}

.costPer100gText {
  font-family: "Marianne";
  font-weight: 500;
}

.pointsText {
  font-family: "Marianne";
  font-weight: 700;
}

.environmentalCostText {
  font-family: "Marianne";
  font-weight: 400;
  letter-spacing: 0;
}
